import React from "react";

import ReviewsData from "./ReviewsData";

import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/splide/dist/css/splide.min.css";
function Testimonials() {
  return (
    <div className="my-[160px]  flex flex-col justify-center m-auto overflow-hidden">
      <div className="mb-[40px] px-[250px] demitablet:px-0 text-center">
        <h1 className="main-X-titles flex justify-center font-font1 font-bold">
          Testimonials
        </h1>
        <p className="demitablet:text-[14px]">
          We are proud to serve a diverse and global client base, with satisfied
          customers in every corner of the world.
        </p>
      </div>

      <div className=" justify-center">
        <Splide
          options={{
            rewind: true,
            gap: 40,
            perPage: 2,
            drag: "free",
            height: "23rem",
            wheel: true,
            focus: "center",
            autoplay: true,
            interval: 3000,

            breakpoints: {
              900: {
                perPage: 1,
              },
            },

            arrows: false,
          }}
        >
          {ReviewsData.map((data, index) => {
            return (
              <SplideSlide key={index} className=" px-4">
                <div
                  key={data.id}
                  className="flex flex-col flex-start h-[310px] px-14 phonex2:px-8 text-center shadow-lg  py-14   rounded-md m-auto justify-center items-center "
                >
                  <img
                    src={data.img}
                    alt="img"
                    className="md:h-20 md:w-20 h-16 w-16 object-cover rounded-full"
                  />
                  <h1 className="font-font2 text-gray-900 text-[17px] md:text-[20px] py-2">
                    {data.name}
                  </h1>
                  <div className=" line-clamp-3">
                    <p className="text-gray-700 w-full break-words demitablet:text-[14px] ">
                      {data.description}
                    </p>
                  </div>
                </div>
              </SplideSlide>
            );
          })}
        </Splide>
      </div>
    </div>
  );
}

export default Testimonials;
